/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-empty-function */

import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'app-input-mount',
	templateUrl: './input-mount.component.html',
	providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputMountComponent), multi: true }],
	styleUrls: ['./input-mount.component.scss']
})
export class InputMountComponent implements ControlValueAccessor {
	@Input() valueText = '';
	@Input() limitsFormat = false;
	@Input() disabled = false;
	@Input() symbolCoin?: string;
	@Input() required = false;
	@Input() errorText = '* El monto es obligatorio';
	@Input() submit = false;
	@Input() classStyle? = '';
	@Input() inputClass? = '';
	@Input() minDecimals = 2;
	@Input() maxDecimals = 2;
	private _onChange = (_value: string) => {};
	private _onTouched = () => {};

	writeValue(value: string): void {
		if (value) {
			this.valueText = value;
		}
	}

	changeEvent(value: string): void {
		this.valueText = value;
		this._onTouched();
		this._onChange(this.value);
	}

	registerOnChange(fn: any): void {
		this._onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this._onTouched = fn;
	}

	setDisabledState(disabled: boolean): void {
		this.disabled = disabled;
	}

	get value(): string {
		return this.valueText;
	}

	set value(val: string) {
		this.valueText = val;
		this._onChange(val);
		this._onTouched();
	}
}
